import * as React from "react"

import { GlobalState } from "../../../store"
import { useAppDispatch, useAppSelector } from "../../../hooks"

import { fetchFields } from "../slice"
import { Field } from "./Field"
import { ConceptCode } from "../../../apis/utils/constants"

export interface OwnProps {
    fieldId: string
}

type Props = OwnProps

export const ItemDetailField = ({ fieldId }: Props): JSX.Element => {
    const {
        fields,
        isLoading = false,
        isInitialized,
    } = useAppSelector((state: GlobalState) => state.fields)
    const dispatch = useAppDispatch()

    React.useEffect(() => {
        if (!isInitialized && !isLoading) {
            dispatch(fetchFields())
        }
    }, [isInitialized, isLoading])

    let field = fields?.[fieldId] ?? null

    if (!field) {
        return <></>
    }

    const itemType = fields?.[ConceptCode]?.itemType ?? ""
    field = { ...field, itemType: itemType }

    return <Field field={field} isLoading={isLoading} />
}

export default ItemDetailField
